import { API_BASE_URL } from "../app/utils";
import { authFetch } from "../app/common";

export const getWallets = (page, size) =>
  authFetch(`${API_BASE_URL}/wallet/v1/wallets?page=${page}&size=${size}`, {
    crossDomain: true,
    method: "GET",
    headers: { "Content-Type": "application/json" },
  }).then(res => res.json());

export const getUserWallet = (userId) =>
  authFetch(`${API_BASE_URL}/wallet/v1/wallets?userId=${userId}`, {
    crossDomain: true,
    method: "GET",
    headers: { "Content-Type": "application/json" },
  }).then(res => res.json());

export const topUpWallet = (walletId, data) =>
  authFetch(`${API_BASE_URL}/wallet/v1/wallets/${walletId}/top-up`, {
    crossDomain: true,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  }).then(res => res.json());

export const getAllWalletTransactions = (walletId, page, size) =>
  authFetch(`${API_BASE_URL}/wallet/v1/wallets/${walletId}/transactions?page=${page}&size=${size}`, {
    crossDomain: true,
    method: "GET",
    headers: { "Content-Type": "application/json" },
  }).then(res => res.json());

export const getAllWalletPayments = async (walletId, page, size, status) =>
  authFetch(`${API_BASE_URL}/wallet/v1/wallets/${walletId}/payments?page=${page}&size=${size}&status=${status}`, {
    crossDomain: true,
    method: "GET",
    headers: { "Content-Type": "application/json" },
  }).then(res => res.json());

export const updateWallet = async (walletId, data) =>
  authFetch(`${API_BASE_URL}/wallet/v1/wallets/${walletId}`, {
    crossDomain: true,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  }).then(res => res.json());

const parseOrThrow = async (res) => {
  const body = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(body?.message || `Request failed with status ${res.status}`);
  }
  return body;
};

export const getAllWalletCharges = async (walletId, page, size) =>
  authFetch(`${API_BASE_URL}/wallet/v1/wallets/${walletId}/charges?page=${page}&size=${size}`, {
    crossDomain: true,
    method: "GET",
    headers: { "Content-Type": "application/json" },
  }).then(parseOrThrow);

export const refundCharge = async (walletId, chargeId, data) =>
  authFetch(`${API_BASE_URL}/wallet/v1/wallets/${walletId}/charges/${chargeId}/refunds`, {
    crossDomain: true,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  }).then(parseOrThrow);

export const getChargeRefund = async (walletId, chargeId, refundId) =>
  authFetch(`${API_BASE_URL}/wallet/v1/wallets/${walletId}/charges/${chargeId}/refunds/${refundId}`, {
    crossDomain: true,
    method: "GET",
    headers: { "Content-Type": "application/json" },
  }).then(parseOrThrow);